<template>
  <section class="p-5">
    Notifications Page
  </section>
</template>

<script>
export default {};
</script>
